// Author Lin
// Date 2021-08-04 16:32:23

import * as model from "@/model/sithMes/mst/SithMesMstKamListModel.js";
import {newEntityStoreHelper} from "@/store/common/entityModule";

function newFilter(paginationFilter = {}) {
    var filter = Object.assign({}, paginationFilter, model.filter)
    return filter;
}

export default newEntityStoreHelper(() => new model.SithMesMstKamList(),newFilter)
    .withStates({
        baseModuleUrl: process.env.VUE_APP_SITHMES_MST_URL,
    })
    .buildStore()
